import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUserGraduate, 
  faFlask, 
  faHandshake, 
  faBookOpen,
  faArrowRight,
  faStethoscope,
  faHeartPulse,
  faUserNurse
} from '@fortawesome/free-solid-svg-icons';
import '../styles/About.css';

const AboutSection = () => {
  const features = [
    {
      icon: faUserGraduate,
      title: 'Dosen Berpengalaman',
      desc: 'Tenaga pengajar profesional dengan kualifikasi S2/S3',
      color: '#3b82f6'
    },
    {
      icon: faFlask,
      title: 'Fasilitas Modern',
      desc: 'Laboratorium & ruang simulasi berstandar nasional',
      color: '#8b5cf6'
    },
    {
      icon: faHandshake,
      title: 'Kerjasama Luas',
      desc: '50+ Rumah Sakit dan klinik mitra praktik',
      color: '#10b981'
    },
    {
      icon: faBookOpen,
      title: 'Kurikulum Terkini',
      desc: 'Berbasis kompetensi dan kebutuhan industri',
      color: '#f59e0b'
    }
  ];

  return (
    <section className="section about-section">
      <div className="container">
        <div className="about-wrapper">
          {/* Left Content */}
          <div className="about-content">
            <span className="about-badge">Tentang Kami</span>
            <h2>Profil STIKES Baramuli</h2>
            <p className="lead">
              Mencetak Tenaga Kesehatan Profesional Berkualitas
            </p>
            <p>
              Sekolah Tinggi Ilmu Kesehatan Baramuli (STIKES Baramuli) adalah institusi 
              pendidikan tinggi kesehatan yang berkomitmen menghasilkan lulusan 
              yang kompeten, beretika, dan profesional dalam bidang kesehatan.
            </p>
            <p>
              Dengan dukungan fasilitas modern, kurikulum berbasis kompetensi, 
              dan tenaga pengajar berpengalaman, kami siap membantu Anda meraih 
              cita-cita menjadi tenaga kesehatan yang handal.
            </p>

            <Link to="/profil" className="btn btn-primary btn-with-icon">
              <span>Selengkapnya</span>
              <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          </div>

          {/* Right Visual */}
          <div className="about-visual">
            <div className="about-visual-main">
              <div className="visual-bg"></div>
              <div className="visual-icons">
                <div className="visual-icon icon-1">
                  <FontAwesomeIcon icon={faStethoscope} />
                </div>
                <div className="visual-icon icon-2">
                  <FontAwesomeIcon icon={faHeartPulse} />
                </div>
                <div className="visual-icon icon-3">
                  <FontAwesomeIcon icon={faUserNurse} />
                </div>
              </div>
              <div className="visual-center">
                <img src="/images/logo.png" alt="STIKES Baramuli" />
              </div>
            </div>
            <div className="about-stats-badge">
              <h3>20+</h3>
              <p>Tahun Mengabdi</p>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="about-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="about-feature-card">
              <div className="feature-icon" style={{ background: `${feature.color}15`, color: feature.color }}>
                <FontAwesomeIcon icon={feature.icon} />
              </div>
              <div className="feature-content">
                <h4>{feature.title}</h4>
                <p>{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
